// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DateFns from "lumi-rescript/lib/es6/src/DateFns.res.js";
import * as LumiSVG from "lumi-rescript/lib/es6/src/LumiSVG.res.js";
import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.res.js";
import * as V2$Linear from "lumi-linear/lib/es6/src/V2.res.js";
import * as Rect$Linear from "lumi-linear/lib/es6/src/Rect.res.js";
import * as Rectf$Linear from "lumi-linear/lib/es6/src/Rectf.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Locale$LumiI18n from "lumi-i18n/lib/es6/src/Locale.res.js";
import Format from "date-fns/format";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as DateTime$LumiI18n from "lumi-i18n/lib/es6/src/DateTime.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Document$LumiStore from "lumi-store/lib/es6/src/Document.res.js";
import * as Translation$Dashboard from "./Translation.res.js";
import * as RightAngle$LumiDocuments from "lumi-documents/lib/es6/src/Types/RightAngle.res.js";
import FormatDistanceStrict from "date-fns/formatDistanceStrict";

function AbandonedVehicleReport$Field(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("label", {
          children: JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
            entry: props.label
          }),
          className: "label"
        }),
        className: "field-label is-normal"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("div", {
            children: props.children,
            className: "control"
          }),
          className: "field is-expanded"
        }),
        className: "field-body"
      })
    ],
    className: "field is-horizontal"
  });
}

let Field = {
  make: AbandonedVehicleReport$Field
};

function AbandonedVehicleReport$TextInput(props) {
  return JsxRuntime.jsx("input", {
    defaultValue: props.defaultValue,
    className: "input",
    type: "text"
  });
}

let TextInput = {
  make: AbandonedVehicleReport$TextInput
};

function AbandonedVehicleReport$TextAreaInput(props) {
  return JsxRuntime.jsx("textarea", {
    defaultValue: props.defaultValue,
    className: "textarea"
  });
}

let TextAreaInput = {
  make: AbandonedVehicleReport$TextAreaInput
};

function AbandonedVehicleReport$Image(props) {
  let match = props.image;
  let snapshot = match.snapshot;
  let revRot = RightAngle$LumiDocuments.RightAngle.reverse(snapshot.imgRotation);
  let raabb = RightAngle$LumiDocuments.RightAngle.applyToRecti(revRot, match.placeAABB);
  let viewBox = LumiSVG.ViewBox.Float.fromRect(Rectf$Linear.scaleCenter(Rect$Linear.map(raabb, prim => prim), 1.02));
  let transform = LumiSVG.Transform.Degree.rotate(RightAngle$LumiDocuments.RightAngle.toDegrees(revRot));
  let match$1 = V2$Linear.map(snapshot.imgResolution, x => x.toString());
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("header", {
        children: JsxRuntime.jsx("p", {
          children: JsxRuntime.jsx(DateTime$LumiI18n.Full.make, {
            date: match.creationTime
          }),
          className: "card-header-title"
        }),
        className: "card-header"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("svg", {
          children: JsxRuntime.jsx("g", {
            children: JsxRuntime.jsx("image", {
              height: match$1[1],
              href: match.imageUrl,
              width: match$1[0],
              x: "0",
              y: "0"
            }),
            transform: transform
          }),
          className: "image",
          preserveAspectRatio: "xMidYMid meet",
          viewBox: viewBox
        }),
        className: "card-image is-flex is-justify-content-center"
      })
    ],
    className: "card"
  });
}

let Image = {
  make: AbandonedVehicleReport$Image
};

function AbandonedVehicleReport(props) {
  let occupationDetails = props.occupationDetails;
  let locale = Locale$LumiI18n.useContext();
  let now = LumiReact.CurrentTime.useCurrentTime();
  let match = Document$LumiStore.contents(occupationDetails.occupation);
  let effectiveEndTime = Stdlib_Option.getOr(match.endTime, now);
  let occupationDuration = FormatDistanceStrict(match.beginTime, effectiveEndTime, {
    unit: "day",
    roundingMethod: "floor",
    locale: Primitive_option.some(Locale$LumiI18n.toDateFnsLocale(locale))
  });
  let today = Format(now, DateFns.Formats.long, {
    locale: Primitive_option.some(Locale$LumiI18n.toDateFnsLocale(locale))
  });
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: LumiReact.renderOption(undefined, occupationDetails.oldestSnapshot, image => JsxRuntime.jsx(AbandonedVehicleReport$Image, {
              image: image
            })),
            className: "column is-narrow"
          }),
          JsxRuntime.jsx("div", {
            children: LumiReact.renderOption(undefined, occupationDetails.latestSnapshot, image => JsxRuntime.jsx(AbandonedVehicleReport$Image, {
              image: image
            })),
            className: "column is-narrow"
          })
        ],
        className: "columns is-justify-content-center"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(AbandonedVehicleReport$Field, {
            label: "Facility",
            children: JsxRuntime.jsx(AbandonedVehicleReport$TextInput, {
              defaultValue: props.facilityMap.name
            })
          }),
          JsxRuntime.jsx(AbandonedVehicleReport$Field, {
            label: "Spot",
            children: JsxRuntime.jsx(AbandonedVehicleReport$TextInput, {
              defaultValue: props.sensor.name
            })
          }),
          JsxRuntime.jsx(AbandonedVehicleReport$Field, {
            label: "OccupationDuration",
            children: JsxRuntime.jsx(AbandonedVehicleReport$TextInput, {
              defaultValue: occupationDuration
            })
          }),
          JsxRuntime.jsx(AbandonedVehicleReport$Field, {
            label: "DateOfRemoval",
            children: JsxRuntime.jsx(AbandonedVehicleReport$TextInput, {
              defaultValue: today
            })
          }),
          JsxRuntime.jsx(AbandonedVehicleReport$Field, {
            label: "VehicleMake",
            children: JsxRuntime.jsx(AbandonedVehicleReport$TextInput, {})
          }),
          JsxRuntime.jsx(AbandonedVehicleReport$Field, {
            label: "VehicleType",
            children: JsxRuntime.jsx(AbandonedVehicleReport$TextInput, {})
          }),
          JsxRuntime.jsx(AbandonedVehicleReport$Field, {
            label: "VehicleColor",
            children: JsxRuntime.jsx(AbandonedVehicleReport$TextInput, {})
          }),
          JsxRuntime.jsx(AbandonedVehicleReport$Field, {
            label: "VehicleSubscriptionNumber",
            children: JsxRuntime.jsx(AbandonedVehicleReport$TextInput, {})
          }),
          JsxRuntime.jsx(AbandonedVehicleReport$Field, {
            label: "VehicleDescriptionAndDamages",
            children: JsxRuntime.jsx(AbandonedVehicleReport$TextAreaInput, {})
          }),
          JsxRuntime.jsx(AbandonedVehicleReport$Field, {
            label: "VehicleFrameNumber",
            children: JsxRuntime.jsx(AbandonedVehicleReport$TextInput, {})
          }),
          JsxRuntime.jsx(AbandonedVehicleReport$Field, {
            label: "Signature",
            children: JsxRuntime.jsx(AbandonedVehicleReport$TextAreaInput, {})
          })
        ]
      })
    ],
    className: "abandoned-vehicle-report"
  });
}

let make = AbandonedVehicleReport;

export {
  Field,
  TextInput,
  TextAreaInput,
  Image,
  make,
}
/* LumiSVG Not a pure module */
